import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AuthService } from "src/app/core/services/auth.service";

@Component({
  selector: "app-time-out",
  templateUrl: "./time-out.component.html",
  styleUrls: ["./time-out.component.scss"],
})
export class TimeOutComponent implements OnInit {
  timeOut: boolean = false;
  isIdle: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private auth: AuthService,
    private dialogRef: MatDialogRef<TimeOutComponent>,
    private dialog: MatDialog,
  ) {
  
  }
  ngOnInit(): void {}
  logout() {
    this.dialog.closeAll();
    this.auth.logout();
  }
  continue() {
    this.dialogRef.close();
  }
}
